module.exports = "/fonts/nucleo-icons.woff?8e954b749f951b654fc62af57004390a";